export class InventoryFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "CloudProviderFilters",
            "format": ""
        },
        {
            "name": "isMutedViolation",
            "baseName": "isMutedViolation",
            "type": "BooleanFilters",
            "format": ""
        },
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "ResourceIdFilters",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "ResourceNameFilters",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceTypeFilters",
            "format": ""
        },
        {
            "name": "environment",
            "baseName": "environment",
            "type": "EnvironmentFilters",
            "format": ""
        },
        {
            "name": "accountId",
            "baseName": "accountId",
            "type": "AccountIdFilters",
            "format": ""
        },
        {
            "name": "accountDisplayName",
            "baseName": "accountDisplayName",
            "type": "AccountDisplayNameFilters",
            "format": ""
        },
        {
            "name": "apps",
            "baseName": "apps",
            "type": "AppFilters",
            "format": ""
        },
        {
            "name": "sourceRegion",
            "baseName": "sourceRegion",
            "type": "SourceRegionFilters",
            "format": ""
        },
        {
            "name": "vpc",
            "baseName": "vpc",
            "type": "VpcPropertyFilters",
            "format": ""
        },
        {
            "name": "subnets",
            "baseName": "subnets",
            "type": "SubnetFilters",
            "format": ""
        },
        {
            "name": "dataClasses",
            "baseName": "dataClasses",
            "type": "DataClassesFilters",
            "format": ""
        },
        {
            "name": "dataClassEntities",
            "baseName": "dataClassEntities",
            "type": "DataClassEntitiesFilters",
            "format": ""
        },
        {
            "name": "backupPolicies",
            "baseName": "backupPolicies",
            "type": "BackupPoliciesFilters",
            "format": ""
        },
        {
            "name": "dlsgPolicies",
            "baseName": "dlsgPolicies",
            "type": "DlsgPolicyFilters",
            "format": ""
        },
        {
            "name": "vaults",
            "baseName": "vaults",
            "type": "VaultFilters",
            "format": ""
        },
        {
            "name": "clusterName",
            "baseName": "clusterName",
            "type": "ClusterNameFilters",
            "format": ""
        },
        {
            "name": "backupStatus",
            "baseName": "backupStatus",
            "type": "BackupStatusFilters",
            "format": ""
        },
        {
            "name": "backupRegions",
            "baseName": "backupRegions",
            "type": "BackupRegionsFilters",
            "format": ""
        },
        {
            "name": "severity",
            "baseName": "severity",
            "type": "SeverityFilters",
            "format": ""
        },
        {
            "name": "controls",
            "baseName": "controls",
            "type": "ControlsFilters",
            "format": ""
        },
        {
            "name": "tagKeys",
            "baseName": "tagKeys",
            "type": "TagKeysFilters",
            "format": ""
        },
        {
            "name": "tagKeyValues",
            "baseName": "tagKeyValues",
            "type": "TagKeyValuesFilters",
            "format": ""
        },
        {
            "name": "freeText",
            "baseName": "freeText",
            "type": "FreeTextFilters",
            "format": ""
        },
        {
            "name": "quotaStatus",
            "baseName": "quotaStatus",
            "type": "QuotaStatusFilters",
            "format": ""
        },
        {
            "name": "sensitivityLabels",
            "baseName": "sensitivityLabels",
            "type": "SensitivityLabelsFilters",
            "format": ""
        },
        {
            "name": "threatDetection",
            "baseName": "threatDetection",
            "type": "ThreatDetectionFilters",
            "format": ""
        },
        {
            "name": "issues",
            "baseName": "issues",
            "type": "IssuesFilters",
            "format": ""
        },
        {
            "name": "restoreTemplateId",
            "baseName": "restoreTemplateId",
            "type": "RestoreTemplateIdFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return InventoryFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
